import { createSlice, current, type PayloadAction } from '@reduxjs/toolkit';
import { isShallowIdentical } from 'utils/isShallowIdentical';
import { DeviceTypeEnum, OrientationTypeEnum, type UserAgent, type UserAgentWithMobile } from 'utils/platform';

const initialState: UserAgentWithMobile = {
  orientation: OrientationTypeEnum.Landscape,
  deviceType: DeviceTypeEnum.Desktop,
  isMobile: false,
};

export const { reducer: userAgentReducer, actions: userAgentActions } = createSlice({
  name: 'userAgent',
  initialState,
  reducers: {
    setUserAgent: (state, { payload }: PayloadAction<UserAgent>) => {
      const { orientation, deviceType } = payload;

      if (
        isShallowIdentical(current(state).orientation, orientation) &&
        isShallowIdentical(current(state).deviceType, deviceType)
      ) {
        return;
      }

      return {
        ...state,
        orientation,
        deviceType,
      };
    },
    setIsMobile: (state, { payload: isMobile }: PayloadAction<UserAgentWithMobile['isMobile']>) => {
      if (isShallowIdentical(current(state).isMobile, isMobile)) {
        return;
      }

      return { ...state, isMobile };
    },
  },
});
